const translations = {
    'settings.configTitle': 'Konfiguracja (JSON)',
    'settings.editHint': 'Edytuj w panelu poniżej.',
    'settings.error': 'Błąd: %s',
    'settings.invalidJson': 'Nieprawidłowy JSON',
    'settings.overlayLabel': 'JSON konfiguracji',
    'settings.reset': 'Resetuj',
    'settings.save': 'Zapisz',
    'settings.storageHint': 'Konfiguracja jest zapisana w localStorage.',
    'settings.tabConfig': 'Konfiguracja',
    'settings.tabAudio': 'Dźwięk',
    'settings.audio.title': 'Dźwięk',
    'settings.audio.background': 'Tło',
    'settings.audio.bell': 'Dzwon',
    'settings.audio.hit': 'Pętla hitów',
    'settings.audio.on': 'Wł.',
    'settings.audio.off': 'Wył.',
    'settings.audio.toggle': 'Przełącz',
    'settings.audio.setVolume': 'Ustaw głośność',
    'settings.audio.status': '%s: %s (głośn. %s)',
    'settings.audio.volumePrompt': 'Ustaw głośność %s (0-1):',
    'settings.title': 'Ustawienia',
};

export default translations;
